module.exports = __webpack_public_path__ + "media/images/green_light_hover-4a98078888c312cb27b5609898296497.jpg";